"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-top: 20px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 20px 14px 0;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 20px 1.3em;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var HubInfoContainer = _styledComponents.default.div.withConfig({
  displayName: "HubInfoContainer",
  componentId: "sc-1dhltd-0"
})(["max-width:1280px;margin:0 auto;margin-top:-458px;padding:35px 40px 0;", ";", ";", ";"], _responsiveBreakpoints.default.tablet(_templateObject()), _responsiveBreakpoints.default.tabletPortrait(_templateObject2()), _responsiveBreakpoints.default.phone(_templateObject3()));

var _default = HubInfoContainer;
exports.default = _default;
module.exports = exports.default;